import React, { useState, useEffect } from "react";
import { T } from "../Translate";
import { Typography, AppBar, Toolbar, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../../session";
import { useNavigate } from "react-router-dom";
import Atras from "../BackButton";

function TripsHeader() {
  const { placeId } = useParams();
  const [placeName, setPlaceName] = useState("");

  useEffect(() => {
    const fetchPlaceData = async () => {
      try {
        const db = getFirestore();
        const placeDocRef = doc(db, "places", placeId);
        const placeDocSnapshot = await getDoc(placeDocRef);

        if (placeDocSnapshot.exists()) {
          const placeData = placeDocSnapshot.data();
          const name = placeData.title || <T>Lugar</T>;
          setPlaceName(name);
        } else {
          console.error("No se encontro el lugar");
        }
      } catch (error) {
        console.error("Error fetching place data:", error);
      }
    };

    if (placeId) {
      fetchPlaceData();
    }
  }, [placeId]);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <AppBar position="fixed">
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            maxWidth: { xs: "100%", md: "980px" },
            mx: "auto",
            px: 2,
            boxSizing: "border-box",
          }}
        >
          <Atras color="inherit" />
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {placeName || <T>Lugar</T>}
            </Typography>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TripsHeader;
